document.addEventListener("DOMContentLoaded", function () {
    const resendControls = document.querySelectorAll(".js-two-factor-resend-countdown");

    resendControls.forEach((control) => {
        const resendAvailableAtUtc = control.dataset.resendAvailableAtUtc;

        if (!resendAvailableAtUtc) {
            return;
        }

        const availableAtMs = Date.parse(resendAvailableAtUtc);

        if (Number.isNaN(availableAtMs)) {
            return;
        }

        const labelElement = control.querySelector(".button-text");
        const fallbackLabel = control.textContent ? control.textContent.trim() : "Send a new code";
        const baseLabel = labelElement ? labelElement.textContent.trim() : fallbackLabel;

        const render = () => {
            const remainingSeconds = Math.ceil((availableAtMs - Date.now()) / 1000);

            if (remainingSeconds > 0) {
                control.disabled = true;
                control.setAttribute("aria-disabled", "true");

                if (labelElement) {
                    labelElement.textContent = `${baseLabel} (${remainingSeconds}s)`;
                } else {
                    control.textContent = `${baseLabel} (${remainingSeconds}s)`;
                }

                return false;
            }

            control.disabled = false;
            control.setAttribute("aria-disabled", "false");

            if (labelElement) {
                labelElement.textContent = baseLabel;
            } else {
                control.textContent = baseLabel;
            }

            return true;
        };

        if (render()) {
            return;
        }

        const intervalId = setInterval(() => {
            if (render()) {
                clearInterval(intervalId);
            }
        }, 1000);
    });
});
